import React from "react";

import { ReactComponent as IconSms } from "../../../../build/images/nps-dashboard-icons/icon-sms.svg";
import { ReactComponent as IconEmail } from "../../../../build/images/nps-dashboard-icons/icon-email.svg";
import { ReactComponent as IconVoice } from "../../../../build/images/nps-dashboard-icons/icon-voice.svg";
import { ReactComponent as IconRcs } from "../../../../build/images/nps-dashboard-icons/icon-rcs.svg";
import { ReactComponent as IconWhatsapp } from "../../../../build/images/nps-dashboard-icons/icon-whatsapp.svg";

import "./card-channel-based.styles.css";

const CardChannelBased = ({ midiaId, sent, answered }) => {
  function renderIconByMidaId(id) {
    switch (id) {
      case 15:
        return <IconRcs />;
      case 3:
        return <IconEmail />;
      case 5:
        return <IconWhatsapp />;
      case 12:
        return <IconSms />;
      default:
        return null;
    }
  }
  return (
    <div className="card-channel-based">
      <div className="card-channel-based__icon">
        {renderIconByMidaId(midiaId)}
      </div>
      <div className="card-channel-based__values">
        <div className="card-channel-based__values__item">
          <div className="card-channel-based__values__item__number">{sent}</div>
          <span className="card-channel-based__values__item__text">
            Enviadas
          </span>
        </div>
        <div className="card-channel-based__values__item">
          <div className="card-channel-based__values__item__number">
            {answered}
          </div>
          <span className="card-channel-based__values__item__text">
            Respondidas
          </span>
        </div>
      </div>
    </div>
  );
};

export default CardChannelBased;
